import { minorToMajor } from "@libs/money";
import {
  vendorOrderFeeMinor,
  type ListingPricing,
  type VendorDeliveryFeeTier,
} from "@libs/buy-on-behalf-contracts/vendor-checkout";

/**
 * What a vendor event's page says it costs before any ticket is chosen: the
 * cheapest ticket at quantity one, with its booking fee and that subtotal's
 * per-order fee. Quantity one is the display convention even when a type's
 * minimum purchase quantity is higher; the sheet enforces purchase limits.
 * `from` when the ticket types do not all come to that. Null when nothing is
 * on sale. A larger order's delivery fee can sit on a higher tier; the tickets
 * sheet shows that exact total.
 */
export function vendorHeadlinePrice(
  journey: ListingPricing & { deliveryFeeTiers?: readonly VendorDeliveryFeeTier[] },
): { amount: number; currency: string; from: boolean } | null {
  const totals = journey.tickets
    .filter((ticket) => ticket.available !== false)
    .map((ticket) => {
      const subtotal = ticket.priceMinor + ticket.bookingFeeMinor;
      return subtotal + vendorOrderFeeMinor(journey, subtotal);
    });
  if (!totals.length) return null;
  return {
    amount: minorToMajor(Math.min(...totals), journey.currency),
    currency: journey.currency,
    from: new Set(totals).size > 1,
  };
}
